import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { BaseProvider } from "../BaseProvider";
import { GlobalService } from "../../_global/global.service";

@Injectable()
export class ProductmasterService extends BaseProvider {
    products = "products";
    constructor(private http: Http, private _gs: GlobalService) {
        super(http);
    }
    getAllProducts() {
        return this.makeGetCall(this.products);
    }
    getAllProductsWithPartner(partnerID: any) {
        return this.makeGetCall(this.products + "?partnerId=" + partnerID);
    }
    getPurposeDocumentList(purpose: any, product: string) {
        return this.makeGetCall("purposes" + "?purpose=" + purpose + "&product=" + product);

    }
    sendEmail(purpose: any, email: any) {
        return this.makeGetCall("purposes" + "?purpose=" + purpose + "&emailId=" + email);

    }
    getPartnerProductPurpose(partnerId, product) {
        return this.makeGetCall("partnerProductPurpose?partnerId=" + partnerId + "&product=" + product)
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/productmaster/productmaster.service.ts